webpackJsonp([171582649688654],{

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _sideNav = __webpack_require__(10);
	
	var _sideNav2 = _interopRequireDefault(_sideNav);
	
	__webpack_require__(281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = ['services', 'vendor', 'brokering', 'consulting'];
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'consulting-hero' },
	      _react2.default.createElement('div', { className: 'consulting-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'consulting-title' },
	      'Consulting'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'consulting-content' },
	      _react2.default.createElement(_sideNav2.default, { components: components, base: 'services', current: 'consulting' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Leasing Solutions LLC is available for consulting on industry projects, as well as assisting in the collection and resolution of seemingly intractable problem relationships.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Leasing Solutions LLC can act as an intermediary between leasing companies/lease brokers and banks/funding sources for the sale of equipment lease and financing agreements. The many contacts acquired throughout ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'experience-link', to: 'experience/' },
	          'Steve Geller\'s'
	        ),
	        ' career have enabled him to enter this area of business and successfully place new business. He acts as a consultant to leasing companies and brokers in the review and structure of new business and the sale of portfolios. He also represents banks in the undertaking of "due diligence" reviews for portfolio and company acquisitions.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you are interested in using Leasing Solutions consulting service, please ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'contact-us', to: '/contact' },
	          'contact us'
	        ),
	        '.'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-consulting-js-30790cc91efb85512f09.js